import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "geobox"
    }}>{`Geobox`}</h1>
    <p>{`Geobox Provide you the options to Add Map related option as meta keys to your post type. you can find the Geobox menu under`}</p>
    <pre><code parentName="pre" {...{}}>{`Admin -> Reactive -> Geobox section,
`}</code></pre>
    <p>{`Here, you can select the post type you want to `}<strong parentName="p">{`enable the Geobox`}</strong></p>
    <p>{`you can see that we have enable the Geobox for `}<strong parentName="p">{`Property post type`}</strong>{`, Now if you add an new property post you will find that the Geobox map and fields are there. here is the attached screenshot from a new property post,`}</p>
    <p>{`Well, now you can insert your location related data from here. if you want to use our Map feature we will recommended you to use our Geobox settings as it weill be better for searching by our plugin.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      